export const environment = {
  production: true,
  oauth_url: 'https://gpdashboard.epa.gov/request/api/oauth2',
  local_service_endpoint: '/request/api',
  recaptcha_siteKey: '6Lev_vEoAAAAAAL-XT_NvvmRWQBTHL1Cig_Z6cQU',
  snackbar_duration: 6000
};
